<template>
    <MenuBase :hidden="props.hidden" 
        :tooltipPosition="props.tooltipPosition" :theme="props.theme" 
        :tooltipText="props.tooltipText"
        @menuClick="openPresentation()">
        <PresentationChartBarIcon class="size-6" />
    </MenuBase>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { PresentationChartBarIcon } from '@heroicons/vue/24/outline';

const emit = defineEmits(['openPresentation'])
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top'
    },
    theme: {
        type: String,
        default: 'light'
    },
    tooltipText: {
        type: String,
        default: 'Download PDF'
    }
})

const openPresentation = () => {
    emit('openPresentation');
}
</script>